// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WEB UNIVERSAL COLOR PALETTE COMBINATION */
/* #1A2238   #9DAAF2     #FF6A3D #F4DB7D * { */
/* DARKBLUE  LIGHTBLUE   ORANGE  YELLOW * { */
/* WEB UNIVERSAL COLOR PALETTE COMBINATION */
/* #1A2238   #9DAAF2     #FF6A3D #F4DB7D * { */
/* DARKBLUE  LIGHTBLUE   ORANGE  YELLOW * { */
:root {
  --blackBg: #010101;
  --light-blackBg: #051423;
  --light-grey: #f2f5f7;
  --darkGrey: #b6b4b4;
  --primaryColor: #1a2238;
  --primaryLightColor: #9daaf2;
  --secondaryColor: #ff6a3d;
  --secondaryOrangeColor: #ff9800;
  --secondaryLightColor: #f4db7d;

  --text-color-dark: #223651;
  --text-color-light: #f6f6f6;

  --success-green: #03cea4;
  --error-red: #db3069;
  --alert-yellow: #fada5e;

  --borderRadius: 4px;

  --minWidthDesktopHuge: 1920px;
  --minWidthDesktopExtraLargePlus: 1670px;
  --minWidthDesktopExtraLarge: 1440px;
  --minWidthDesktopLarge: 1281px;
  --minWidthDesktopMiddle: 1200px;
  --minWidthIpadPro: 1024px;
  --maxWidthIpadPro: 1023px;
  --minWidthDesktop: 992px;
  --minWidthTablet: 768px;
  --maxWidthTablet: 767px;
  --minWidthPhoneMiddleLandscape: 640px;
  --minWidthPhoneMiddle: 576px;
  --minWidthPhoneRotated: 500px;
  --minWidthPhoneLastGeneration: 370px;
  --minWidthPhone: 320px;
}

* {
  box-sizing: border-box;
}

*:before,
*:after {
  box-sizing: border-box;
}

html p {
  font-size: 16px;
}
@media screen and (min-width: 320px) {
  html p {
    font-size: calc(16px + 6 * ((100vw - 320px) / 680));
  }
}
@media screen and (min-width: 1000px) {
  html p {
    font-size: 22px;
  }
}

body {
  position: relative;
  font-family: 'Roboto', serif;
  margin: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Advent Pro', sans-serif;
  letter-spacing: 0.03em;
  margin: 0;
}

h1,
h2,
h3,
h4 {
  line-height: 1.2;
  font-weight: 400;
}
h5,
h6 {
  line-height: 1;
  font-weight: 200;
}

h1 {
  font-size: 6vw;
}

h2 {
  font-size: 4.5vw;
}

h2.tit-box {
  font-size: calc(30px + (35 - 25) * ((100vw - 600px) / (1600 - 900)));
}

h3 {
  font-size: calc(30px + (15 - 14) * ((100vw - 600px) / (1600 - 900)));
}
h4 {
  font-size: calc(20px + (11 - 7) * ((100vw - 600px) / (1600 - 900)));
}
h5 {
  font-size: calc(18px + (9 - 5) * ((100vw - 600px) / (1600 - 900)));
}
h6 {
  font-size: calc(17px + (8 - 4) * ((100vw - 600px) / (1600 - 900)));
}

ul {
  display: -webkit-flex;
  /* targets Chrome, Safar i */
  display: -ms-flexbox;
  /* targets IE10 */
  display: flex;
  flex-direction: column;
  list-style-type: none;
}

li {
  text-decoration: none;
}

li::before(:not(.nodecoration)) {
  content: '•';
  color: var(--secondaryLightColor);
  padding-right: 11px;
}

/* nav props applying in Navigation and BurgerMenu*/

nav {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 1em;
  align-self: center;
  /* margin: 2rem; */
}

a {
  text-decoration: none;
  cursor: pointer;
}
a:hover {
  color: var(--primaryLightColor) !important;
  transition: color 1s;
}
a:not(.dont-underline):after {
  content: '';
  position: absolute;
  width: 5%;
  transform: scaleX(0);
  height: 2px;
  margin-top: 2px;
  background-color: var(--secondaryLightColor);
  transform-origin: bottom right;
  transition: transform 0.5s ease-out;
}
a:not(.dont-underline):hover:after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

/* .body-block {
    height: 100vh;
} */

textarea {
  height: 150px;
  padding: 12px 60px;
  margin-bottom: 2rem;
  border: 2px solid var(--darkGrey);
  border-radius: 4px;
  background-color: var(--light-grey);
  opacity: 0.8;
  resize: none;
  color: var(--text-color-dark);
  font-size: 16px;
}

input[type='text'] {
  padding: 12px 60px;
  margin: 1px 0;
  box-sizing: border-box;
  border: none;
  border-bottom: 2px solid var(--darkGrey);
  opacity: 0.8;
  color: var(--text-color-dark);
  font-size: 16px;
  width: 80%;
}

/* ADDRESS MOBILE-PHONES AND TABLETS*/

@media only screen and (max-width: 650px) {
  input[type='text'] {
    margin: 3px 0;
    box-sizing: border-box;
    border: none;
    border-bottom: 2px solid var(--darkGrey);
    opacity: 0.8;
    color: var(--text-color-dark);
    font-size: 14px;
  }

  textarea {
    box-sizing: border-box;
    border: none;
    border-bottom: 2px solid var(--darkGrey);
    opacity: 0.8;
    color: var(--text-color-dark);
    font-size: 14px;
  }
}

/* ADDRESS TABLETS AND NORMAL PCS */

@media only screen and (max-width: 1200px) {
  input[type='text'] {
    margin: 5px 0;
    box-sizing: border-box;
    border: none;
    border-bottom: 2px solid var(--darkGrey);
    opacity: 0.8;
    color: var(--text-color-dark);
    font-size: 14px;
  }

  textarea {
    box-sizing: border-box;
    border: none;
    border-bottom: 2px solid var(--darkGrey);
    opacity: 0.8;
    color: var(--text-color-dark);
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C,8CAA8C;AAC9C,6CAA6C;AAC7C,4CAA4C;AAC5C,8CAA8C;AAC9C,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;;EAE9B,0BAA0B;EAC1B,2BAA2B;;EAE3B,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;;EAEvB,mBAAmB;;EAEnB,6BAA6B;EAC7B,uCAAuC;EACvC,mCAAmC;EACnC,8BAA8B;EAC9B,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;AACA;EACE;IACE,mDAAmD;EACrD;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;;;;;;EAME,qCAAqC;EACrC,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;EAIE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,oEAAoE;AACtE;AACA;EACE,mEAAmE;AACrE;AACA;EACE,kEAAkE;AACpE;AACA;EACE,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,mDAAmD;;AAEnD;EACE,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,4CAA4C;EAC5C,8BAA8B;EAC9B,mCAAmC;AACrC;AACA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;EACxC,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,UAAU;AACZ;;AAEA,qCAAqC;;AAErC;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,6BAA6B;IAC7B,eAAe;EACjB;AACF;;AAEA,mCAAmC;;AAEnC;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,6BAA6B;IAC7B,eAAe;EACjB;AACF","sourcesContent":["/* WEB UNIVERSAL COLOR PALETTE COMBINATION */\n/* #1A2238   #9DAAF2     #FF6A3D #F4DB7D * { */\n/* DARKBLUE  LIGHTBLUE   ORANGE  YELLOW * { */\n/* WEB UNIVERSAL COLOR PALETTE COMBINATION */\n/* #1A2238   #9DAAF2     #FF6A3D #F4DB7D * { */\n/* DARKBLUE  LIGHTBLUE   ORANGE  YELLOW * { */\n:root {\n  --blackBg: #010101;\n  --light-blackBg: #051423;\n  --light-grey: #f2f5f7;\n  --darkGrey: #b6b4b4;\n  --primaryColor: #1a2238;\n  --primaryLightColor: #9daaf2;\n  --secondaryColor: #ff6a3d;\n  --secondaryOrangeColor: #ff9800;\n  --secondaryLightColor: #f4db7d;\n\n  --text-color-dark: #223651;\n  --text-color-light: #f6f6f6;\n\n  --success-green: #03cea4;\n  --error-red: #db3069;\n  --alert-yellow: #fada5e;\n\n  --borderRadius: 4px;\n\n  --minWidthDesktopHuge: 1920px;\n  --minWidthDesktopExtraLargePlus: 1670px;\n  --minWidthDesktopExtraLarge: 1440px;\n  --minWidthDesktopLarge: 1281px;\n  --minWidthDesktopMiddle: 1200px;\n  --minWidthIpadPro: 1024px;\n  --maxWidthIpadPro: 1023px;\n  --minWidthDesktop: 992px;\n  --minWidthTablet: 768px;\n  --maxWidthTablet: 767px;\n  --minWidthPhoneMiddleLandscape: 640px;\n  --minWidthPhoneMiddle: 576px;\n  --minWidthPhoneRotated: 500px;\n  --minWidthPhoneLastGeneration: 370px;\n  --minWidthPhone: 320px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\nhtml p {\n  font-size: 16px;\n}\n@media screen and (min-width: 320px) {\n  html p {\n    font-size: calc(16px + 6 * ((100vw - 320px) / 680));\n  }\n}\n@media screen and (min-width: 1000px) {\n  html p {\n    font-size: 22px;\n  }\n}\n\nbody {\n  position: relative;\n  font-family: 'Roboto', serif;\n  margin: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: 'Advent Pro', sans-serif;\n  letter-spacing: 0.03em;\n  margin: 0;\n}\n\nh1,\nh2,\nh3,\nh4 {\n  line-height: 1.2;\n  font-weight: 400;\n}\nh5,\nh6 {\n  line-height: 1;\n  font-weight: 200;\n}\n\nh1 {\n  font-size: 6vw;\n}\n\nh2 {\n  font-size: 4.5vw;\n}\n\nh2.tit-box {\n  font-size: calc(30px + (35 - 25) * ((100vw - 600px) / (1600 - 900)));\n}\n\nh3 {\n  font-size: calc(30px + (15 - 14) * ((100vw - 600px) / (1600 - 900)));\n}\nh4 {\n  font-size: calc(20px + (11 - 7) * ((100vw - 600px) / (1600 - 900)));\n}\nh5 {\n  font-size: calc(18px + (9 - 5) * ((100vw - 600px) / (1600 - 900)));\n}\nh6 {\n  font-size: calc(17px + (8 - 4) * ((100vw - 600px) / (1600 - 900)));\n}\n\nul {\n  display: -webkit-flex;\n  /* targets Chrome, Safar i */\n  display: -ms-flexbox;\n  /* targets IE10 */\n  display: flex;\n  flex-direction: column;\n  list-style-type: none;\n}\n\nli {\n  text-decoration: none;\n}\n\nli::before(:not(.nodecoration)) {\n  content: '•';\n  color: var(--secondaryLightColor);\n  padding-right: 11px;\n}\n\n/* nav props applying in Navigation and BurgerMenu*/\n\nnav {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-gap: 1em;\n  align-self: center;\n  /* margin: 2rem; */\n}\n\na {\n  text-decoration: none;\n  cursor: pointer;\n}\na:hover {\n  color: var(--primaryLightColor) !important;\n  transition: color 1s;\n}\na:not(.dont-underline):after {\n  content: '';\n  position: absolute;\n  width: 5%;\n  transform: scaleX(0);\n  height: 2px;\n  margin-top: 2px;\n  background-color: var(--secondaryLightColor);\n  transform-origin: bottom right;\n  transition: transform 0.5s ease-out;\n}\na:not(.dont-underline):hover:after {\n  transform: scaleX(1);\n  transform-origin: bottom left;\n}\n\n/* .body-block {\n    height: 100vh;\n} */\n\ntextarea {\n  height: 150px;\n  padding: 12px 60px;\n  margin-bottom: 2rem;\n  border: 2px solid var(--darkGrey);\n  border-radius: 4px;\n  background-color: var(--light-grey);\n  opacity: 0.8;\n  resize: none;\n  color: var(--text-color-dark);\n  font-size: 16px;\n}\n\ninput[type='text'] {\n  padding: 12px 60px;\n  margin: 1px 0;\n  box-sizing: border-box;\n  border: none;\n  border-bottom: 2px solid var(--darkGrey);\n  opacity: 0.8;\n  color: var(--text-color-dark);\n  font-size: 16px;\n  width: 80%;\n}\n\n/* ADDRESS MOBILE-PHONES AND TABLETS*/\n\n@media only screen and (max-width: 650px) {\n  input[type='text'] {\n    margin: 3px 0;\n    box-sizing: border-box;\n    border: none;\n    border-bottom: 2px solid var(--darkGrey);\n    opacity: 0.8;\n    color: var(--text-color-dark);\n    font-size: 14px;\n  }\n\n  textarea {\n    box-sizing: border-box;\n    border: none;\n    border-bottom: 2px solid var(--darkGrey);\n    opacity: 0.8;\n    color: var(--text-color-dark);\n    font-size: 14px;\n  }\n}\n\n/* ADDRESS TABLETS AND NORMAL PCS */\n\n@media only screen and (max-width: 1200px) {\n  input[type='text'] {\n    margin: 5px 0;\n    box-sizing: border-box;\n    border: none;\n    border-bottom: 2px solid var(--darkGrey);\n    opacity: 0.8;\n    color: var(--text-color-dark);\n    font-size: 14px;\n  }\n\n  textarea {\n    box-sizing: border-box;\n    border: none;\n    border-bottom: 2px solid var(--darkGrey);\n    opacity: 0.8;\n    color: var(--text-color-dark);\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
